import {
  DELETE_SHIPPING_PROVIDER,
  INSERT_SHIPPING_PROVIDER
} from 'graphql/mutations/integrations';
import * as Yup from 'yup';

const fedexData = {
  key: 'FEDEX',
  createMutation: INSERT_SHIPPING_PROVIDER,
  deleteMutation: DELETE_SHIPPING_PROVIDER,
  noDisplayFields: [
    { name: 'clientId', path: 'clientId' },
    { name: 'providerId', path: 'id' }
  ],
  getMixedTypes: (params) => {
    return {
      service: () => {
        const notAvailableItems = params?.integrationsData?.map(
          (item) => item.service
        );

        return ['NACIONAL', 'PROGRAMADO', 'EXPRESS'].filter(
          (item) => !notAvailableItems?.includes(item)
        );
      }
    };
  },
  fields: [
    {
      title: 'Alias',
      label: 'Ej. Primera integración',
      keyName: 'alias',
      type: '',
      initialValue: '',
      helperText: 'Introduce un nombre para identificar esta integración',
      validationSchema: Yup.string().required('Ingresa el campo Alias')
    },
    {
      title: 'Servicio',
      label: 'Ej. PROGRAMADO',
      keyName: 'service',
      type: [],
      initialValue: '',
      helperText: 'Introduce el tipo de servicio',
      validationSchema: Yup.string().required('Ingresa el campo SERVICIO')
    },
    {
      label: 'Metadata',
      keyName: 'metadata',
      type: {},
      fields: [
        {
          title: 'CLIENT ID',
          label: 'Ej: clent_id_example',
          keyName: 'client_id',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu CLIENT ID',
          validationSchema: Yup.string().required('Ingresa el campo CLIENT ID')
        },
        {
          title: 'GRANT TYPE',
          label: 'Ej: client_credentials',
          keyName: 'client_id',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu GRANT TYPE',
          validationSchema: Yup.string().required('Ingresa el campo GRANT TYPE')
        },
        {
          title: 'CLIENT SECRET',
          label: 'Ej: client_secret_example',
          keyName: 'client_id',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu CLIENT SECRET',
          validationSchema: Yup.string().required(
            'Ingresa el campo CLIENT SECRET'
          )
        },
        {
          title: 'ACCOUNT NUMBER',
          label: 'Ej: account_number_example',
          keyName: 'account_number',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu ACCOUNT NUMBER',
          validationSchema: Yup.string().required(
            'Ingresa el campo ACCOUNT NUMBER'
          )
        },
        {
          title: 'CARRIER CODES',
          label: 'Ej: FDXE,FDXL',
          keyName: 'carrierCodes',
          type: '',
          initialValue: '',
          helperText:
            'Introduce la lista de CARRIER CODES, a modo de una lista separada por comas como se muestra en el ejemplo',
          validationSchema: Yup.string().required(
            'Ingresa el campo CARRIER CODES'
          )
        }
      ]
    }
  ]
};

export default fedexData;
